import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

// import { Eye } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Table from "../../../../core/pagination/datatable";
import NewLead from "./NewLead";
import { Avatar, Select, Spin, Tag } from "antd";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import axios from "axios";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const Leads = () => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );

  const statusColors = {
    New: "green",
    "Follow Up": "blue",
    "Quote Sent": "gold",
    "No Response": "orange",
    "No Answer": "red",
    Customer: "purple",
    Default: "default",
  };

  const sourceColors = {
    website: "blue",
    referral: "green",
    facebook: "cyan",
    imdiamart: "purple",
    instagram: "magenta",
    whatsapp: "green",
    call: "orange",
    google: "red",
    default: "default",
  };

  const cardConfig = {
    New: {
      border: "secondary",
      iconBg: "bg-cyan-transparent text-cyan",
      icon: "fa-layer-group",
    },
    Customer: {
      border: "success",
      iconBg: "bg-success bg-opacity-10 text-success",
      icon: "fa-user-check",
    },
    "Quote Sent": {
      border: "warning",
      iconBg: "bg-warning bg-opacity-10 text-warning",
      icon: "fa-file-invoice",
    },
    conversation: {
      border: "primary",
      iconBg: "bg-primary bg-opacity-10 text-primary",
      icon: "fa-comments",
    },
    "No Answer": {
      border: "danger",
      iconBg: "bg-danger bg-opacity-10 text-danger",
      icon: "fa-phone-slash",
    },
    "Follow Up": {
      border: "dark",
      iconBg: "bg-dark bg-opacity-10 text-dark",
      icon: "fa-envelope-open",
    },
  };

  const [leadsData, setLeadsData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [sorceData, setSorceData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  // const [leadsCountData, setLeadsCountData] = useState([]);
  const [statusCards, setStatusCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staffLoading, setStaffLoading] = useState(false);
  const [sourceLoading, setSourceLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  // const [leadsCountLoading, setLeadsCountLoading] = useState(false);
  // const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [selectedSource, setSelectedSource] = useState(0);
  const [selectedAssignTo, setSelectedAssignTo] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);

  const [showLead, setShowLead] = useState(false);

  console.log(statusData, "leadddddddddd");

  const getStatusDropDown = async () => {
    setStatusLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadStatus`);

      if (response.data.Status) {
        const options = response.data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setStatusData(options);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No status data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Status API Error:", error);
    } finally {
      setStatusLoading(false);
    }
  };

  const columns = [
    {
      title: "Lead",
      dataIndex: "name",
      key: "name",

      sorter: (a, b) =>
        (a.name || "").localeCompare(b.name || "", undefined, {
          sensitivity: "base",
        }),

      sortDirections: ["ascend", "descend"],

      render: (_, record) => {
        const initials = record.name
          ?.split(" ")
          .slice(0, 2)
          .map((x) => x[0])
          .join("")
          .toUpperCase();

        const avatarColor =
          statusColors[record.StatusName] === "green"
            ? "#52c41a"
            : statusColors[record.StatusName] === "blue"
              ? "#1677ff"
              : statusColors[record.StatusName] === "orange"
                ? "#fa8c16"
                : statusColors[record.StatusName] === "red"
                  ? "#ff4d4f"
                  : statusColors[record.StatusName] === "purple"
                    ? "#722ed1"
                    : "#6c757d";

        return (
          <div className="d-flex align-items-start">
            <div className="position-relative">
              <Avatar
                size={39}
                style={{
                  backgroundColor: avatarColor,
                  fontWeight: 700,
                  fontSize: 17,
                }}
              >
                {initials}
              </Avatar>

              <span
                className={`position-absolute bottom-0 end-0 border border-white rounded-circle ${
                  record.active ? "bg-success" : "bg-danger"
                }`}
                style={{
                  width: 11,
                  height: 11,
                }}
              />
            </div>

            <Link to={`/crm/viewleads/${record.id}`} className="ms-3">
              <div className="fw-semibold" title={record.name}>
                {record.name?.length > 20
                  ? `${record.name.substring(0, 20)}...`
                  : record.name}
              </div>

              <small className="text-muted" title={record.company}>
                <i className="fa-solid fa-building text-info me-2"></i>
                {record.company?.length > 20
                  ? `${record.company.substring(0, 20)}...`
                  : record.company}
              </small>
            </Link>
          </div>
        );
      },
    },

    {
      title: "Contact",
      dataIndex: "email",
      key: "email",

      sorter: (a, b) =>
        (a.email || "").localeCompare(b.email || "", undefined, {
          sensitivity: "base",
        }),

      sortDirections: ["ascend", "descend"],

      render: (_, record) => (
        <>
          <div>
            <i className="fa-regular fa-envelope text-primary me-2"></i>
            <a href={`mailto:${record.email}`} className="text-decoration-none">
              {record.email}
            </a>
          </div>

          <small className="text-muted d-flex align-items-center mt-1">
            <a
              href={`tel:${record.phonenumber}`}
              className="text-decoration-none text-muted"
            >
              <i className="fa-solid fa-phone text-success me-2"></i>
              <span>{record.phonenumber}</span>
            </a>

            <a
              href={`https://wa.me/${record.phonenumber?.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ms-3"
              title="Chat on WhatsApp"
            >
              <i
                className="fa-brands fa-whatsapp text-success"
                style={{ fontSize: "16px" }}
              ></i>
            </a>
          </small>
        </>
      ),
    },

    {
      title: "Date",
      dataIndex: "dateadded",
      key: "dateadded",

      sorter: (a, b) => {
        const dateA = a.dateadded ? dayjs(a.dateadded).valueOf() : 0;
        const dateB = b.dateadded ? dayjs(b.dateadded).valueOf() : 0;

        return dateA - dateB;
      },

      sortDirections: ["ascend", "descend"],

      render: (date) => (
        <span>{date ? dayjs(date).format("DD-MM-YYYY") : "-"}</span>
      ),
    },

    {
      title: "Source",
      dataIndex: "SourceName",
      key: "SourceName",

      sorter: (a, b) =>
        (a.SourceName || "").localeCompare(b.SourceName || "", undefined, {
          sensitivity: "base",
        }),

      sortDirections: ["ascend", "descend"],

      render: (text) => {
        const sourceKey = text?.trim().toLowerCase();

        return (
          <Tag
            color={sourceColors[sourceKey] || sourceColors.default}
            bordered={false}
            style={{
              borderRadius: 20,
              padding: "4px 12px",
              fontWeight: 500,
            }}
          >
            <i className="fa-solid fa-bullseye me-2"></i>
            {text || "N/A"}
          </Tag>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",
      key: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "New":
              return "#6c757d";
            case "Quote Sent":
              return "#0d6efd";
            case "No Answer":
              return "#ffc107";
            case "No Response":
              return "#198754";
            case "Customer":
              return "#dc3545";
            case "conversation":
              return "#ffc107";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              statusData.find((item) => item.label === (text || "New"))?.value
            }
            style={{ width: 130 }}
            options={statusData}
            onChange={(value) => {
              updateInvoiceStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = statusData.find((x) => x.value === value);

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Assigned To",
      dataIndex: "AssignedTo",
      key: "AssignedTo",

      sorter: (a, b) =>
        (a.AssignedTo || "").localeCompare(b.AssignedTo || "", undefined, {
          sensitivity: "base",
        }),

      sortDirections: ["ascend", "descend"],

      render: (text) => (
        <>
          <i className="fa-solid fa-user-tie text-success me-2"></i>
          {text || "N/A"}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      width: 70,

      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              to={`/crm/viewleads/${record.id}`}
              className="me-2 p-2 shadow-sm"
            >
              <i className="ti ti-eye text-info"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  //integration part

  const getLeads = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_CRM_URL}leads/GetLeadsByStatus`,
        {
          params: {
            statusId: selectedStatus,
            sourceId: selectedSource,
            assignTo: selectedAssignTo,
          },
        },
      );

      if (response.data.Status) {
        setLeadsData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No leads found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Leads API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStaffDropDown = async () => {
    setStaffLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}staff/GetStaffDropdown`);

      if (response.data.Status) {
        setStaffData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No staff data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Leads API Error:", error);
    } finally {
      setStaffLoading(false);
    }
  };

  const getSourceDropDown = async () => {
    setSourceLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadSources`);

      if (response.data.Status) {
        setSorceData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No source data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Source API Error:", error);
    } finally {
      setSourceLoading(false);
    }
  };

  const getLeadsCount = async () => {
    // setLeadsCountLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadCounts`);

      if (response.data.Status) {
        const dashboard = response.data.ResultData[0];
        // setLeadsCountData(response.data.ResultData || []);
        setStatusCards(dashboard.StatusWiseLeads || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No leadcount data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("leadcount API Error:", error);
    }
    // finally {
    //   setLeadsCountLoading(false);
    // }
  };

  const updateInvoiceStatus = async (ProjectId, statusId) => {
    try {
      const response = await fetch(`${BASE_CRM_URL}leads/UpdateLeadStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: ProjectId,
          statusid: statusId,
          addedfrom: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });
        getLeadsCount();
        getLeads();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getStaffDropDown();
    getSourceDropDown();
    getStatusDropDown();
    getLeadsCount();
  }, []);

  useEffect(() => {
    getLeads();
  }, [selectedStatus, selectedSource, selectedAssignTo]);

  // const assignedOptions = [
  //   { value: 0, label: "All" },
  //   ...staffData.map((staff) => ({
  //     value: staff.staffid,
  //     label: staff.firstname,
  //   })),
  // ];

  // const sorceOptions = [
  //   { value: 0, label: "All" },
  //   ...sorceData.map((sorce) => ({
  //     value: sorce.SourceId,
  //     label: sorce.SourceName,
  //   })),
  // ];

  // const statusOptions = [
  //   { value: 0, label: "All" },
  //   ...statusCards.map((status) => ({
  //     value: status.StatusId,
  //     label: status.StatusName,
  //   })),
  // ];
  const assignedOptions = [
    { value: 0, label: "All" },
    ...staffData.map((staff) => ({
      value: Number(staff.staffid),
      label: staff.firstname,
    })),
  ];

  const sorceOptions = [
    { value: 0, label: "All" },
    ...sorceData.map((sorce) => ({
      value: Number(sorce.SourceId),
      label: sorce.SourceName,
    })),
  ];

  const statusOptions = [
    { value: 0, label: "All" },
    ...statusCards.map((status) => ({
      value: Number(status.StatusId),
      label: status.StatusName,
    })),
  ];

  const exportExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Leads");

      // Columns
      worksheet.columns = [
        { header: "Name", key: "name", width: 25 },
        { header: "Company", key: "company", width: 25 },
        { header: "Email", key: "email", width: 32 },
        { header: "Phone", key: "phonenumber", width: 18 },
        { header: "City", key: "city", width: 18 },
        { header: "State", key: "state", width: 18 },
        { header: "Status", key: "StatusName", width: 18 },
        { header: "Source", key: "SourceName", width: 18 },
        { header: "Assigned To", key: "AssignedTo", width: 22 },
        { header: "Date Added", key: "dateadded", width: 22 },
      ];

      // Add data
      leadsData.forEach((lead) => {
        worksheet.addRow({
          name: lead.name ?? "",
          company: lead.company ?? "",
          email: lead.email ?? "",
          phonenumber: lead.phonenumber ?? "",
          city: lead.city ?? "",
          state: lead.state ?? "",

          StatusName: lead.StatusName || "N/A",
          SourceName: lead.SourceName || "N/A",
          AssignedTo: lead.AssignedTo || "N/A",

          dateadded: lead.dateadded
            ? new Date(lead.dateadded).toLocaleString("en-IN")
            : "",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Leads.xlsx");
    } catch (error) {
      console.error("Excel export error:", error);

      Swal.fire("Error", "Failed to generate Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Name",
        "Company",
        "Email",
        "Phone",
        "City",
        "State",
        "Status",
        "Source",
        "Assigned To",
        "Date Added",
      ];

      const rows = leadsData.map((lead) => [
        lead.name ?? "",
        lead.company ?? "",
        lead.email ?? "",
        lead.phonenumber ?? "",
        lead.city ?? "",
        lead.state ?? "",

        lead.StatusName || "N/A",
        lead.SourceName || "N/A",
        lead.AssignedTo || "N/A",

        lead.dateadded ? new Date(lead.dateadded).toLocaleString("en-IN") : "",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Leads Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer center
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Leads.pdf");
    } catch (error) {
      console.error("PDF export error:", error);

      Swal.fire("Error", "Failed to generate PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="d-flex justify-content-between">
          {/* Left section with heading and description */}
          <div className="d-flex flex-column">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item " aria-current="page">
                  Leads
                </h4>
              </ol>
            </nav>
            <p className="text-muted">Manage and add new Leads</p>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <ul className="table-top-head d-flex align-items-center mb-0">
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={exportPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={exportExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              {/* <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li> */}
            </ul>
            {/* Right section with buttons */}
            <div className="d-flex">
              <div className="ms-2 ">
                <Link
                  to="#"
                  className="btn btn-success btn-sm text-white"
                  onClick={() => setShowLead(true)}
                >
                  <i className="ti ti-circle-plus fs-4 "></i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row my-2">
          {statusCards.map((item, index) => {
            if (index >= 4) return null;

            const config = cardConfig[item.StatusName] || {
              border: "secondary",
              iconBg: "bg-secondary bg-opacity-10 text-secondary",
              icon: "fa-circle",
            };

            return (
              <div
                key={item.StatusId}
                className="col-12 col-md-6 col-lg-3 d-flex"
              >
                <div
                  className={`card revenue-widget flex-fill border shadow-sm`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedStatus(item.StatusId)}
                >
                  <div
                    className="card-body d-flex justify-content-between align-items-center py-2 px-3"
                    style={{ minHeight: "55px" }}
                  >
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                      <h4 className="mb-0  fw-bold">{item.LeadCount}</h4>
                      <p className="fw-semibold">{item.StatusName}</p>
                    </div>
                    <div
                      className={`revenue-icon ${config.iconBg} rounded-circle bg-opacity-10  d-flex align-items-center justify-content-center flex-shrink-0`}
                    >
                      <i className={`fa-solid ${config.icon} fs-16`} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="card table-list-card " style={{ marginTop: "-1rem" }}>
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap ">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto ">
              <div className="dropdown me-2" style={{ width: 150 }}>
                {/* <Select
                  placeholder="Assigned To"
                  style={{ height: 38 }}
                  options={assignedOptions}
                  value={assignedOptions.find(
                    (x) => x.value === selectedAssignTo,
                  )}
                  onChange={(option) => setSelectedAssignTo(option?.value ?? 0)}
                  className="w-100"
                  loading={staffLoading}
                /> */}
                <label className="form-label mb-1">Assigned To</label>
                <Select
                  placeholder="Assigned To"
                  style={{ height: 38, width: "100%" }}
                  options={assignedOptions}
                  value={assignedOptions.find(
                    (x) => x.value === Number(selectedAssignTo),
                  )}
                  onChange={(value) => {
                    console.log("SELECTED:", value);
                    setSelectedAssignTo(value ?? 0);
                  }}
                  loading={staffLoading}
                />
              </div>
              <div className="dropdown me-2" style={{ width: 150 }}>
                <label className="form-label mb-1">Status</label>
                <Select
                  placeholder="Status"
                  style={{ height: 38 }}
                  options={statusOptions}
                  value={statusOptions.find((x) => x.value === selectedStatus)}
                  onChange={(option) => setSelectedStatus(option ?? 0)}
                  className="w-100"
                  loading={statusLoading}
                />
              </div>
              <div className="dropdown me-2" style={{ width: 150 }}>
                <label className="form-label mb-1">Source</label>
                <Select
                  placeholder="Source"
                  style={{ height: 38 }}
                  options={sorceOptions}
                  value={sorceOptions.find((x) => x.value === selectedSource)}
                  onChange={(option) => setSelectedSource(option ?? 0)}
                  className="w-100"
                  loading={sourceLoading}
                />
              </div>

              <button
                type="button"
                className="btn btn-secondary mt-4"
                style={{ height: 38 }}
                onClick={() => {
                  setSelectedAssignTo(0);
                  setSelectedStatus(0);
                  setSelectedSource(0);
                }}
              >
                Reset
              </button>
            </div>
          </div>

          <div className="card-body p-0">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={leadsData} />
              )}
            </div>
          </div>
        </div>
      </div>
      <>
        <NewLead
          show={showLead}
          onClose={() => setShowLead(false)}
          getLeads={getLeads}
        />
      </>
    </div>
  );
};

export default Leads;
